export const ENV = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_WOO_URL: process.env.REACT_APP_API_URL,
  REACT_APP_WOO_CK: process.env.REACT_APP_API_URL,
  REACT_APP_WOO_CS: process.env.REACT_APP_API_URL
};
